<style src="./base.css" scoped></style>
<style src="./elements.css" scoped></style>
<style>@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,800;1,800&display=swap');</style>

<template>
  <div class="user-profile-container">
    <h2 class="profile-title">User Profile</h2>
    <div class="square-container">
      <div v-if="user">
        <p class="profile-email"><strong>Email:</strong> {{ user.email }}</p>
        <form @submit.prevent="updateProfile" class="profile-form">
          <div class="form-group">
            <label for="firstName" class="form-label">First Name</label>
            <input
              type="text"
              id="firstName"
              v-model="profile.firstName"
              required
              class="form-input"
            />
          </div>
          <div class="form-group">
            <label for="middleName" class="form-label">Middle name</label>
            <input
              type="text"
              id="middleName"
              v-model="profile.middleName"
              class="form-input"
            />
          </div>
          <div class="form-group">
            <label for="surname" class="form-label">Surname</label>
            <input
              type="text"
              id="surname"
              v-model="profile.surname"
              required
              class="form-input"
            />
          </div>
          <div class="form-group">
            <label for="position" class="form-label">Position</label>
            <input
              type="text"
              id="position"
              v-model="profile.position"
              class="form-input"
            />
          </div>
          <div class="form-group">
            <label for="team" class="form-label">Team</label>
            <input
              type="text"
              id="team"
              v-model="profile.team"
              class="form-input"
            />
          </div>
          <div class="form-group">
            <label for="client" class="form-label">Client</label>
            <input
              type="text"
              id="client"
              v-model="profile.client"
              class="form-input"
            />
          </div>
          <button type="submit" class="action-button">Update profile</button>
        </form>
        <div class="reset-btn-container">
          <button @click="resetPassword" class="action-outline-button">Reset password</button>
        </div>
        <p v-if="message" class="profile-message">{{ message }}</p>
      </div>
      <div v-else>
        <p class="loading-text">Loading profile...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { auth, db } from "../firebaseConfig";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { sendPasswordResetEmail } from "firebase/auth";

export default {
  name: "UserProfile",
  data() {
    return {
      user: null,
      profile: {
        firstName: "",
        middleName: "",
        surname: "",
        position: "",
        team: "",
        client: ""
      },
      message: ""
    };
  },
  async created() {
    this.user = auth.currentUser;
    if (this.user) {
      const userDocRef = doc(db, "users", this.user.uid);
      const userDocSnap = await getDoc(userDocRef);
      if (userDocSnap.exists()) {
        const data = userDocSnap.data();
        this.profile = {
          firstName: data.firstName || "",
          middleName: data.middleName || "",
          surname: data.surname || "",
          position: data.position || "",
          team: data.team || "",
          client: data.client || ""
        };
      }
    }
  },
  methods: {
    async updateProfile() {
      if (!this.user) return;
      try {
        const userDocRef = doc(db, "users", this.user.uid);
        await setDoc(
          userDocRef,
          {
            firstName: this.profile.firstName,
            middleName: this.profile.middleName,
            surname: this.profile.surname,
            position: this.profile.position,
            team: this.profile.team,
            client: this.profile.client,
            email: this.user.email
          },
          { merge: true }
        );
        this.message = "Profile updated successfully!";
      } catch (error) {
        console.error("Error updating profile:", error);
        this.message = "Failed to update profile.";
      }
    },
    async resetPassword() {
      try {
        await sendPasswordResetEmail(auth, this.user.email);
        this.message = "Password reset email sent! Please check your inbox.";
      } catch (error) {
        console.error("Error sending password reset email:", error);
        this.message = "Failed to send password reset email.";
      }
    }
  }
};
</script>

<style scoped>
.user-profile-container {
  min-height: 100vh;
  padding: 1rem 5rem 0rem 5rem;
}

.square-container {
  max-width: 500px;
  margin: 0 auto;
}

.profile-title {
  font-size: 30px;
    font-weight: 600;
    margin-bottom: 30px;
    margin-top: 30px;
}

.profile-email {
  margin-bottom: 2rem;
  text-align: center;
  color: #C9BF9B;
}

.profile-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group {
  font-weight: 800;
  display: flex;
  flex-direction: column;
}

.form-label {
  margin-bottom: 0.3rem;
}

.form-input {
    font-family: "Courier Prime", monospace;
    font-weight: 400;
    font-style: normal;
    padding: 10px;
    border: 1px solid #C9BF9B;
    box-shadow: inset 0px 4px 3px #dacb9736;
    border-radius: 9px;
    font-size: 14px;
    color: #111827;
    background-color: #F8F7F3;
    max-width: 680px;
  }

.action-button,
.action-outline-button {
  margin: 0 auto;
  margin-top: 1rem;
}

.reset-btn-container {
  text-align: center;
}

.profile-message {
  margin-top: 1rem;
  text-align: center;
  color: green;
}

.loading-text {
  text-align: center;
  color: #555555;
}
</style>
